<template>
  <div class="orderBreadCrumb">
    <div>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item
        :class="{ active: item.url === $route.fullPath }"
        :to="item.url"
        v-for="item in breadcrumbList"
        :key="item.id"
        >{{ item.name }}</el-breadcrumb-item
      >
    </div>
    <div
      class="closeCurrntPage"
      v-show="$route.path.search('completeStock') !== -1"
      @click="closeCurrntPage"
    >
      X关闭当前页
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      breadcrumbList: [],
      orderDetailUrl: "",
      // url:
      //   localStorage.getItem("is_jgj") === "1"
      //     ? "/order/manageFastener"
      //     : "/order/manage", // 判断是否为紧固件
      // name:
      //   localStorage.getItem("is_jgj") === "1" ? "待处理" : "三方备货出库单", // 判断是否为紧固件
      orderList: [
        {
          url:
            localStorage.getItem("is_jgj") === "1"
              ? "/order/manageFastener"
              : "/order/manage",
          name:
            localStorage.getItem("is_jgj") === "1"
              ? "待处理订单"
              : "三方备货出库单",
        },
        // { url: '/order/edit', name: '订单明细' },
        { url: "/order/afterSaleManage", name: "三方售后单" },
        { url: "/order/afterSale/edit", name: "售后明细" },
        // { url: '/order/completeStock', name: '备货明细' },
        { url: "/order/scanningStock", name: "扫描出库清单" },
        { url: "/order/dayStockList", name: "备货清单" },
        { url: "/order/shippingList", name: "三方发货清单" },
      ],
    };
  },
  mounted() {
    this.setBreadCrumb(this.$route);
  },
  watch: {
    $route(to, from) {
      this.setBreadCrumb(to);
    },
  },
  methods: {
    setBreadCrumb(to) {
      for (let i of this.orderList) {
        if (i.url === to.path) {
          i.url = to.fullPath;
        }
      }
      // if (this.$route.path.search('order/edit') !== -1) {
      //   this.orderList[1].url = this.$route.fullPath
      // }
      let currentUrl = this.orderList.filter(
        (item) => item.url === to.fullPath
      );
      if (!this.breadcrumbList.some((item) => item.url === to.fullPath)) {
        this.breadcrumbList = this.breadcrumbList.concat(currentUrl);
      }
    },
    closeCurrntPage() {
      this.breadcrumbList = this.breadcrumbList.filter(
        (item) => item.url.search("completeStock") === -1
      );
      if (localStorage.getItem("is_jgj") === "1") {
        // 为紧固件
        this.$router.push("/order/manageFastener");
      } else {
        this.$router.push("/order/manage");
      }
    },
  },
};
</script>
<style lang="scss">
.orderBreadCrumb {
  .closeCurrntPage {
    border-radius: 10px;
    border: 1px solid #dcdfe6;
    cursor: pointer;
    font-size: 14px;
    position: fixed;
    right: 16px;
    line-height: 20px;
    top: 53px;
    text-align: center;
    width: 94px;
    height: 20px;
    border-radius: 5px;
    background-color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/breadcrumb/orderBreadCrumb.vue